<template>
  <v-layout row wrap pa-5>
    <v-flex xs12 md12>
      <v-layout row wrap>
          <v-flex xs12 md4 pa-2>
            <v-text-field
              v-model="uuid"
              label="UUID"
              solo
              hide-details
              clearable
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4 pa-2>
              <v-text-field
                v-model="leadkey"
                label="key"
                solo
                hide-details
                clearable
                :loading="loading"
              ></v-text-field>
          </v-flex>
          <v-flex xs12 md4 pa-2>
            <v-autocomplete
              :items="resource.types"
              v-model="selectedType"
              label="Log Type"
              solo
              hide-details
              return-object
              clearable
              item-value="type"
              item-text="type"
              :loading="loading"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md4 pa-2>
            <v-menu
              v-model="fsd"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="fTLDate"
                  label="From Date"
                  append-icon="event"
                  readonly
                  hide-details
                  clearable
                  solo
                  :loading="loading"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fTLDate" @input="fsd = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md4 pa-2>
            <v-menu
              v-model="tsd"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="tTLDate"
                  label="To Date"
                  append-icon="event"
                  readonly
                  hide-details
                  clearable
                  solo
                  :loading="loading"
                ></v-text-field>
              </template>
              <v-date-picker v-model="tTLDate" @input="tsd = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md4 pa-2>
              <v-autocomplete
                :items="resource.countries"
                v-model="selectedCountry"
                label="Country"
                solo
                hide-details
                return-object
                clearable
                item-value="id"
                item-text="name"
                :loading="loading"
              ></v-autocomplete>
            </v-flex>
          <v-flex xs12 md3 pa-2>
            <v-switch label="Proccessd" hide-details v-model="proccessed"></v-switch>
          </v-flex>
          <v-flex xs12 md3 pa-2>
            <v-switch label="Not Proccessd" hide-details v-model="not_proccessed"></v-switch>
          </v-flex>
          <v-flex xs12 md3 pa-2>
            <v-switch label="Synced Ninja" hide-details v-model="synced_ninja"></v-switch>
          </v-flex>
          <v-flex xs12 md3 pa-2>
            <v-switch label="Not Synced Ninja" hide-details v-model="not_synced_ninja"></v-switch>
          </v-flex>
          <v-flex xs12 md3 pa-2>
            <v-switch label="Synced CRM" hide-details v-model="synced_crm"></v-switch>
          </v-flex>
          <v-flex xs12 md3 pa-2>
            <v-switch label="Not Synced CRM" hide-details v-model="not_synced_crm"></v-switch>
          </v-flex>
          <v-flex xs12 md3 pa-2>
            <v-switch label="Show Archived Only" hide-details v-model="archived"></v-switch>
          </v-flex>
          <v-flex xs12 md3>
          </v-flex>
          <v-flex xs12 md12>
            <v-btn block color="primary" @click="loadResource()">load</v-btn>
          </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md12>
      <v-layout row wrap>
        <v-flex xs12 md12 class="text-xs-center" PagingC>
          <Paging :resourceSettings="resourceSettings" :resource="resource" @loadResource="loadResource"
            @pageByNumber="pageByNumber" />
        </v-flex>
        <v-flex xs12 md12 Details>
          <logPanel :resource="resource" :resourceSettings="resourceSettings" @copyS="clipboardSuccessHandler"
            @copyF="clipboardErrorHandler" :loading="loading" :resourceKeys="resourceKeys" @archive="archive" />
        </v-flex>
        <v-flex xs12 md12 class="text-xs-center" PagingC>
          <Paging :resourceSettings="resourceSettings" :resource="resource" @loadResource="loadResource"
            @pageByNumber="pageByNumber" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import catDialog from '@/components/catDialog'
import catsDialog from '@/components/catsDialog'
import logPanel from '@/components/logPanel'
import Filters from '@/components/Filters'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import { firebase, store, db, auth, storageRef } from '@/fb';
import axios from 'axios';
import { crmApiUrl } from '@/config/urls';
const headers = { 'Accept': 'application/json' };

export default {
  components: { Search, Paging, multiDialog, logPanel, Filters, catDialog, catsDialog },
  data() {
    return {
      loading: false,
      dialog: false,
      dialogCategory: false,
      dialogViewCategory: false,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys: [
        
      ],
      categoryKeys: [
      ],
      resourceSettings: {
        resourceName: null,
        search: true,
        pagination: true,
        create: true,
      },
      newResource: { prices: [], images: [], vprices: [], accounts: [], variants: [], vendorsubs: [] },
      newCategory: {},
      editing: false,
      deleting: false,
      filter: '',
      time: 0,
      page: 1,
      warehouses: [],
      selectedType:null,
      not_proccessed: null,
      not_synced_ninja:null,
      not_synced_crm: null,
      proccessed: null,
      synced_ninja: null,
      synced_crm: null,
      fsd: null,
      fTLDate: null,
      tsd: null,
      tTLDate: null,
      uuid:null,
      leadkey: null,
      selectedCountry: null,
    }
  },

  methods: {
    getUpload(o) {
      this.newResource[o.field] = o.value
    },
    editResource(r) {
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    emitsnackbarNotification(a, b) {
      this.$emit('snackbarNotification', a, b)

    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    
    superA() {
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d) {
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
        !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x => { })
    },
    buildFilter() {
      let filter = ``
      if (this.selectedType) {
        filter += `&type=${this.selectedType}`
      }
      if (this.not_proccessed) {
        filter += `&not_proccessed=${this.not_proccessed}`
      }
      if (this.not_synced_ninja) {
        filter += `&not_synced_ninja=${this.not_synced_ninja}`
      }
      if (this.not_synced_crm) {
        filter += `&not_synced_crm=${this.not_synced_crm}`
      }
      if (this.proccessed) {
        filter += `&proccessed=${this.proccessed}`
      }
      if (this.synced_ninja) {
        filter += `&synced_ninja=${this.synced_ninja}`
      }
      if (this.synced_crm) {
        filter += `&synced_crm=${this.synced_crm}`
      }
      if (this.archived) {
        filter += `&archived=${this.archived}`
      }
      if (this.fTLDate) {
        filter += `&from=${this.fTLDate}`
      }
      if (this.tTLDate) {
        filter += `&to=${this.tTLDate}`
      }
      if (this.uuid) {
        filter += `&uuid=${this.uuid.trim()}`
      } 
      if (this.leadkey) {
        filter += `&key=${this.leadkey.trim()}`
      } 
      if (this.selectedCountry) {
        filter += `&country_id=${this.selectedCountry}`
      }
      return filter
    },
    async reLoadResource() {
      this.search = null
      await this.loadResource()
    },
    async archive(r) {
    await axios.put(crmApiUrl(`data-logs/${r.id}`)).then(x => x.data)
      await this.loadResource()
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        let start = new Date().getTime()
        this.loading = true
        console.log(this.search)
        if (!this.search) {
        this.resource = await axios.get(crmApiUrl('data-logs') + `?page=${this.page}` + this.buildFilter()).then(x => x.data)
          console.log(this.resource)
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + '/search', value: this.search })
        }
        let end = new Date().getTime()
        this.time = ((end - start) / 1000).toFixed(1)
        this.loading = false
        res()
      })
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true
        let start = new Date().getTime()
        this.page = n
        if (!this.search) {
          this.resource = await axios.get(crmApiUrl('data-logs') + `?page=${n}` + this.buildFilter()).then(x=>x.data)
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + `/search?page=${n}`, value: this.search })
        }
        let end = new Date().getTime()
        this.time = ((end - start) / 1000).toFixed(1)
        this.loading = false
      })
    },
    async searchResource(search) {
      return new Promise(async (res, rej) => {
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + '/search', value: this.search })
        this.loading = false
      })
    },
    async getWarehouses() {
      return new Promise(async (res, rej) => {
        this.loading = true
        let a = await store.collection('warehouses').get().then(x => x.docs.map(y => y.data()))
        this.warehouses = a.map(x => {
          return {
            quantity: 0,
            warehouse: x.name
          }
        })
        console.log(this.warehouses)
        res(true)
      })
    },
    async postToProductsFirebase(r) {
      return new Promise(async (res, rej) => {
        let {
          active,
          description_ar,
          description_en,
          item_name,
          key,
          name_ar,
          name_en,
          sku,
          note,
        } = r
        let p = {
          active,
          description_ar,
          description_en,
          item_name,
          key,
          name_ar,
          name_en,
          sku,
          note,
        }
        if (r.id) {
          p.id = r.id
        }
        p.img = r.image && r.image.url ? r.image.url : ''
        p.prices = r.prices.map(c => { return { country: c.name, ...c } })
        console.log('r', r)

        let ps = [p, ...r.variants.map(x => {
          return {
            active: r.active,
            img: r.image && r.image.url ? r.image.url : '',
            prices: r.prices.map(c => { return { country: c.name, ...c } }),
            description_ar: r.description_ar,
            description_en: r.description_en,
            item_name: x.name,
            note: r.note,
            key: x.key,
            sku: x.sku,
            name_ar: x.name_ar,
            name_en: x.name_en,
            id: x.id,
          }
        }), ...r.vendorsubs.map(x => {
          return {
            active: r.active,
            img: r.image && r.image.url ? r.image.url : '',
            prices: r.prices.map(c => { return { country: c.name, ...c } }),
            description_ar: r.description_ar,
            description_en: r.description_en,
            item_name: r.item_name,
            note: r.note,
            sku: x.sku,
            key: x.key,
            name_ar: r.name_ar,
            name_en: r.name_en,
            id: x.id,
            account_id: x.account_id
          }
        })
        ];
        console.log(ps)

        for (let i = 0; i < ps.length; i++) {
          const dbi = ps[i];
          let dbp = {}
          for (const key in dbi) {
            if (Object.hasOwnProperty.call(dbi, key)) {
              const val = dbi[key];
              if (val) {
                dbp[key] = val
              }
            }
          }
          console.log(dbp)
          if (!dbp.key) {
            let products = await store.collection("products")
              .where("sku", "==", dbp.sku).get()
              .then(x => x.docs.map(y => {
                return {
                  ...y.data(),
                  alternatives: y.data().alternatives ? y.data().alternatives : [],
                  warehouses: y.data().warehouses ? y.data().warehouses : [],
                  key: y.id
                }
              }));
            let exists = products.length && products[0] && products[0].key
            dbp.key = exists ? products[0].key : null
            dbp.exists = exists
          }

          if ((dbp.key && dbp.id) || dbp.exists) {
            let pin = await db.ref(`productsCore/${dbp.key}`).once('value').then(x => x.val())
            console.log(pin)
            await db.ref(`productsCore/${dbp.key}`).update(dbp)
            await db.ref(`products/${dbp.key}`).update(dbp)
            await db.ref(`productsCoreLite/${dbp.key}`).update(dbp)
            this.$emit('snackbarNotification', `SKU SYNC`, 'success')
          } else {

            let bb = await db.ref('uKeys').push()
            dbp.key = bb.key
            await db.ref(`productsCore/${dbp.key}`).update(dbp)
            await db.ref(`products/${dbp.key}`).update(dbp)
            await db.ref(`productsCoreLite/${dbp.key}`).update(dbp)
            let wn = {
              item_name: dbp.item_name,
              key: dbp.key,
              sku: dbp.sku,
              warehouses: this.warehouses
            }
            console.log(wn)
            await store.collection(`products`).doc(dbp.key).set(wn)
            await store.collection(`productsLive`).doc(dbp.key).set(wn)
            await db.ref('uKeys').update({
              [bb.key]: null
            })
          }
        }
        res(true)
      })
    },
    async updateResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        r.categories = r.categories_id
        console.log('product', r)
        await this.$store.dispatch('putResource', { resource: this.$route.path + `/${r.id}`, value: r })
        await this.postToProductsFirebase(r)
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = { prices: [], images: [], variants: [], vprices: [], accounts: [], vendorsubs: [] }
      })
    },
    async deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        await this.$store.dispatch('deleteResource', { resource: this.$route.path + `/${r.id}` })
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = { prices: [], images: [], variants: [], vprices: [], accounts: [], vendorsubs: [] }
      })
    },
    async postResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        console.log(JSON.stringify(r))
        let bb = await db.ref('uKeys').push()
        r.key = bb.key
        console.log('product', r)
        await this.$store.dispatch('postResource', { resource: this.$route.path + `${r.id ? '/' + r.id : ''}`, value: r })
        await this.postToProductsFirebase(r)
        this.dialog = false
        this.loading = false
        await db.ref('uKeys').update({
          [bb.key]: null
        })
        await this.loadResource()
        this.newResource = { prices: [], images: [], variants: [], vprices: [], accounts: [], vendorsubs: [] }
      })
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
   
  },
  watch: {
  },
  computed: {
    api() {
      return this.$store.state.settings.apiBase
    },
    users() {
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x => {
        if (!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site() {
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin() {
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language() {
      return this.$store.state.language
    },
    globalLoading() {
      return this.$store.state.globalLoading
    },
    user() {
      return this.$store.state.user
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(x => x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x => x.subs)).filter(x => x).filter(x => x.path == this.$route.path)
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles() {
      return this.$store.state.userRoles
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp)
    },
  },
  async created() {
    this.setResourceName()
    await this.loadResource()


  },

}
</script>

<style>
.adminSwitch .v-input {
  margin-top: 0 !important;
}

.adminSwitch .v-input__control {
  margin-bottom: 0 !important;
}

.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>